/**
 * Zero-based positions of each slide in `deckSlides.tsx`. Kept in its own file
 * so slides can link to one another without importing the registry (which
 * imports them back).
 */
export const SLIDE_INDEX = {
  title: 0,
  partnership: 1,
  montage: 2,
  questions: 3,
  whyWhere: 4,
  engagementLayer: 5,
  techStack: 6,
  controlTower: 7,
  scaling: 8,
  pilotOptions: 9,
  closing: 10
} as const
